function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M20 35.67h17.53"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinejoin: "round",
  d: "M28.76 3.54a4.133 4.133 0 115.85 5.84L10.26 33.72l-7.79 2 1.95-7.79L28.76 3.54z"
}));

function SvgBlog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOCAzOCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPGxpbmUgeDE9IjE4IiB4Mj0iMzUuNTMiIHkxPSIzMy42NyIgeTI9IjMzLjY3IiBzdHJva2U9IiMyM0MzODYiLz4KICAgIDxwYXRoIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgZD0iTTI2Ljc2LDEuNTQgQzI4LjM3MjY3MTUsLTAuMDc1NDMyODkzMyAzMC45ODk1NjcxLC0wLjA3NzY3MTQ2OTUgMzIuNjA1LDEuNTM1IEMzNC4yMjA0MzI5LDMuMTQ3NjcxNDcgMzQuMjIyNjcxNSw1Ljc2NDU2NzExIDMyLjYxLDcuMzggTDguMjYsMzEuNzIgTDAuNDcsMzMuNzIgTDIuNDIsMjUuOTMgTDI2Ljc2LDEuNTQgWiIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgBlog as ReactComponent };